import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["beaconsConfigId"];
import { useMemo, Suspense, lazy } from 'react';
import OnboardingBeaconErrorBoundary from './OnboardingBeaconErrorBoundary';
import { useShouldShowBeacon } from './hooks/useShouldShowBeacon';
import { useOnboardingBeaconsStatus, OnboardingBeaconStatus } from './hooks/useOnboardingBeaconStatus';
import { registerLangs } from './utils/beaconCopy';
import { jsx as _jsx } from "react/jsx-runtime";
export const AsyncOnboardingBeaconsContainer = /*#__PURE__*/lazy(async () => {
  const [onboardingBeaconsContainerModule] = await Promise.all([import( /* webpackChunkName: "onboarding-beacons" */'./containers/OnboardingBeaconsContainer'), import( /* webpackChunkName: "onboarding-beacons" */'i2l?query=sporks!../lang/en.lyaml').then(sharedLangModule => registerLangs([sharedLangModule]))]);
  return onboardingBeaconsContainerModule;
});
function OnboardingBeaconsIfNotDismissed(_ref) {
  let {
      beaconsConfigId
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    onboardingBeaconStatus,
    turnOffOnboardingBeacon
  } = useOnboardingBeaconsStatus(beaconsConfigId);
  if (onboardingBeaconStatus !== OnboardingBeaconStatus.NOT_DISMISSED) {
    return null;
  }
  return /*#__PURE__*/_jsx(Suspense, {
    fallback: null,
    children: /*#__PURE__*/_jsx(AsyncOnboardingBeaconsContainer
    // guarantees that the container is re-rendered when the config changes
    // simplifing the logic in `useBeaconsConfig`
    , Object.assign({
      beaconsConfigId: beaconsConfigId,
      turnOffOnboardingBeacon: turnOffOnboardingBeacon
    }, props), beaconsConfigId)
  });
}
const OnboardingBeaconsIfNoOtherPatterns = props => {
  const shouldShowBeacon = useShouldShowBeacon();
  if (!shouldShowBeacon) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingBeaconsIfNotDismissed, Object.assign({}, props));
};

/**
 * @deprecated Use CEM to create beacons instead.
 * See https://product.hubteam.com/docs/unified-engagement-platform/overview/nudge-beacons.html
 */
export default function OnboardingBeacons({
  beaconsConfigId,
  beaconsConfig,
  callbacks,
  root
}) {
  const beaconsConfigIdToUse = useMemo(() => beaconsConfigId || (beaconsConfig === null || beaconsConfig === void 0 ? void 0 : beaconsConfig.beaconsConfigId), [beaconsConfigId, beaconsConfig === null || beaconsConfig === void 0 ? void 0 : beaconsConfig.beaconsConfigId]);
  if (!beaconsConfigIdToUse) {
    return null;
  }
  return /*#__PURE__*/_jsx(OnboardingBeaconErrorBoundary, {
    beaconsConfigId: beaconsConfigIdToUse,
    fallback: null,
    children: /*#__PURE__*/_jsx(OnboardingBeaconsIfNoOtherPatterns, {
      beaconsConfigId: beaconsConfigIdToUse,
      beaconsConfig: beaconsConfig,
      callbacks: callbacks,
      beaconRoot: root
    })
  });
}